import { useMotionValue, useTransform } from 'framer-motion';
import { motion } from "../../Motion-polyfill";
import React from 'react';
import { Description, DivRelative, SubTitle } from '../../components/layouts';
import Sequence from '../../components/sequence';
import { SeqencePlaceholder } from '../../components/sequence/Placeholder';
import Visibility from '../../components/Visibility';
import { AppContext } from '../../Context';
import { getSeqFrames, getTrack, pureTrans } from '../../helpers';
import './style.scss';

const track = getTrack({ block: 16 });

const FRAME_LENGTH = 78;

export function Chip({ mobile = false }) {
  const [framesLoaded, setFramesLoaded] = React.useState(false);
  const [frozen, freeze] = React.useState(true);
  const [index, setIndex] = React.useState(-1);
  const progress = useMotionValue(0);
  const handleUpdate = React.useCallback(
    (e, { calculations }) => {
      const { percentagePassed, pixelsPassed, height, offScreen } = calculations;
      freeze(offScreen || pixelsPassed <= -1000 || pixelsPassed >= height + 1000);
      progress.set(percentagePassed);
      const source = mobile ? [0, 0.8] : [0, 0.8];
      const i = pureTrans(percentagePassed, source, [0, FRAME_LENGTH - 1], 0);
      setIndex(i);
    },
    [progress, freeze, setIndex, mobile]
  );

  const { webpSupport, webpDetectionFinished } = React.useContext(AppContext);

  const frames = React.useMemo(() => {
    return getSeqFrames({
      prefix: 'chip',
      mobile,
      webpSupport: false,
      len: FRAME_LENGTH
    });
  }, [webpSupport, mobile]);

  const ot = useTransform(progress, mobile ? [0, 0.3, 0.65] : [0, 0.3], mobile ? [0, 0.4, 1] : [1, 1]);
  const yt = useTransform(progress, mobile ? [0.5, 0.65, 0.8] : [0, 0.3], mobile ? [10, 0, -10] : [0, 0]);

  const onFramesLoaded = React.useCallback(() => {
    setFramesLoaded(true);
  }, [setFramesLoaded]);

  const seqReady = !frozen && webpDetectionFinished;
  return (
    <Visibility
      fireOnMount
      offset={[-1000, 1000]}
      onUpdate={handleUpdate}
      className="page-section section-chip inverted"
      id="cpu"
      data-track={track}
    >
      <div className="sticky-content">
        <DivRelative>
          <div className="section-content center">
            <motion.div style={{ opacity: ot, y: yt }}>
              <SubTitle>
                5nm旗舰芯片
                <br />
                嘘！别尖叫
              </SubTitle>
              <Description>X60 系列采用行业首批 5nm 制程芯片，不仅性能得到了很大提升，功耗也大幅降低。</Description>
            </motion.div>
          </div>
        </DivRelative>
        <div className="section-background">
          <div className="sequence-wrapper">
            <Sequence name="chip" current={index} onload={onFramesLoaded} frames={frames} active={seqReady} />
            <SeqencePlaceholder src={frames[frames.length - 1]} visible={!seqReady || !framesLoaded} />
          </div>
        </div>
      </div>
    </Visibility>
  );
}
